import Column from "../components/Column";
import DatePicker from "../components/DatePicker";
import Icon from "../components/Icon";
import React, { useEffect, useState } from "react";
import Row from "../components/Row";
import Section from "../components/Section";
import Separator from "../components/Separator";
import Table from "../components/Table";
import { Text, TextTitle } from "../components/Texts";
import colors from "../styles/colors";
import { useDispatch, useSelector } from "react-redux";
import { compose } from "redux";
import withUserPerm from "services/withUserPerm";
import _mapValues from "lodash/mapValues";
import formatMetricValue from "../modules/utils/formatMetricValue";

import campaignAction from "../modules/campaign/actions";
import campaignSelectors from "../modules/campaign/selectors";

import mainSelectors from "../modules/main/selectors";
import { useTranslation } from "react-i18next";
import TopBar from "../components/TopBar";
import styled from "styled-components";
import useWindowSize from "../layout/useWindowSize";

const SearchCampaigns = () => {
  const [selectedViewValue, setSelectedViewValue] = useState();
  const [startPage, setStartPage] = useState(0);
  const [orderType, setOrderType] = useState({ key: "campaign", direction: "asc" });
  const [orderTopKeyword, setOrderTopKeyword] = useState({ key: "clicks", direction: "desc" });
  const listSearchCampaignResult = useSelector((state) => campaignSelectors.listSearchCampaignResult(state));
  const listTopKeywordResult = useSelector((state) => campaignSelectors.listTopKeywordResult(state));
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const dispatch = useDispatch();
  const [t] = useTranslation();

  const onPageChange = (start) => {
    console.log("onPageChange", start);
    setStartPage(start - 1);
  };

  useEffect(() => {
    const rmpToken = sessionStorage.getItem("rmp_token");
    console.log("selectedViewValue", selectedViewValue);
    console.log("listSearchCampaignResult", listSearchCampaignResult);
    if (selectedViewValue) {
      dispatch(
        campaignAction.ListSearchCampaign(
          rmpToken,
          currentAd.ads_account_id,
          selectedViewValue.value.start,
          selectedViewValue.value.end,
          orderType.key,
          orderType.direction,
          startPage,
        ),
      );
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedViewValue, startPage, orderType]);

  useEffect(() => {
    const rmpToken = sessionStorage.getItem("rmp_token");
    console.log("selectedViewValue", selectedViewValue);
    console.log("listTopKeywordResult", listTopKeywordResult);
    if (selectedViewValue) {
      dispatch(
        campaignAction.ListTopKeyword(
          rmpToken,
          currentAd.ads_account_id,
          selectedViewValue.value.start,
          selectedViewValue.value.end,
          orderTopKeyword.key,
          orderTopKeyword.direction,
        ),
      );
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedViewValue, orderTopKeyword]);

  return (
    <div>
      <StyledContainerTop useWindowSize={useWindowSize()}>
        <StyledContainerTopBar useWindowSize={useWindowSize()}>
          <TopBar title={t("__search_campaign")} />
        </StyledContainerTopBar>
        <DatePicker onSelected={setSelectedViewValue} />
      </StyledContainerTop>
      <CampaignTable
        data={listSearchCampaignResult.data.campaign}
        size={5}
        total={listSearchCampaignResult.data.total}
        onPageChange={onPageChange}
        onSortChange={setOrderType}
        orderType={orderType}
      />
      <TopKeywords
        data={listTopKeywordResult.data.topKeyword}
        onSortChange={setOrderTopKeyword}
        orderType={orderTopKeyword}
      />
    </div>
  );
};

export default compose(withUserPerm())(SearchCampaigns);

const CampaignTable = ({ data = [], size, total, onPageChange, onSortChange, orderType }) => {
  console.log("data", data);
  const [t] = useTranslation();
  const tableColumn = [
    {
      key: "campaign",
      title: t("__campaigns"),
      options: {
        width: "160px",
        strongText: true,
        fontSize: "10px",
      },
    },
    {
      key: "cost",
      title: t("__cost"),
      options: {
        align: "right",
      },
    },
    {
      key: "clicks",
      title: t("__clicks"),
      options: {
        align: "right",
      },
    },
    {
      key: "impressions",
      title: t("__impressions"),
      options: {
        align: "right",
      },
    },
    {
      key: "ctr",
      title: t("__ctr"),
      options: {
        align: "right",
        width: "60px",
      },
    },
    {
      key: "conversions",
      title: t("__conversion"),
      options: {
        align: "right",
      },
    },
    {
      key: "cpc",
      title: t("__avg_cpc"),
      options: {
        align: "right",
      },
    },
  ];
  const pagination = { size, total, onPageChange };
  const sortOptions = {
    ...orderType,
    onSelected: onSortChange,
  };
  data = data.map((item) => {
    return _mapValues(item, (value, key) => {
      if (key === "campaign") {
        return item.isTotal ? (
          value
        ) : (
          <TextTitle size="10px" ellipsis={2} tooltip>
            {value}
          </TextTitle>
        );
      } else {
        return formatMetricValue(key, value);
      }
    });
  });
  return (
    <Section margin="0 0 24px">
      <Table
        columns={tableColumn}
        data={data}
        pagination={pagination}
        responsiveColumns={2}
        sortOptions={sortOptions}
      />
    </Section>
  );
};

const TopKeywords = ({ data = [], onSortChange, orderType }) => {
  const [t] = useTranslation();
  console.log("TopKeywords data", data);
  const tableColumn = [
    {
      key: "keyword",
      title: t("__keywords"),
      options: {
        strongText: true,
        fontSize: "10px",
      },
    },
    {
      key: "campaign",
      title: t("__campaigns"),
      options: {
        fontSize: "10px",
      },
    },
    {
      key: "cost",
      title: t("__cost"),
      options: {
        align: "right",
      },
    },
    {
      key: "clicks",
      title: t("__clicks"),
      options: {
        align: "right",
      },
    },
    {
      key: "impressions",
      title: t("__impressions"),
      options: {
        align: "right",
      },
    },
    {
      key: "ctr",
      title: t("__ctr"),
      options: {
        align: "right",
        width: "60px",
      },
    },
    {
      key: "conversions",
      title: t("__conversion"),
      options: {
        align: "right",
      },
    },
    {
      key: "cpc",
      title: t("__avg_cpc"),
      options: {
        align: "right",
      },
    },
  ];
  const sortOptions = {
    ...orderType,
    onSelected: onSortChange,
  };
  data = data.map((item) => {
    return _mapValues(item, (value, key) => {
      if (key === "campaign") {
        return (
          <Text size="10px" ellipsis={2} tooltip>
            {value}
          </Text>
        );
      } else {
        return key !== "keyword" ? formatMetricValue(key, value) : value;
      }
    });
  });

  return (
    <Section margin="0 0 24px">
      <Row alignItems="center">
        <Column wrap>
          <Icon name="icon-award" size="36px" color={colors.primary} />
        </Column>
        <Column>
          <TextTitle size="18px">{t("__top_20_keywords")}</TextTitle>
        </Column>
      </Row>
      <Separator />
      <Table columns={tableColumn} data={data} responsiveColumns={1} freezeColumns={2} sortOptions={sortOptions} />
    </Section>
  );
};

const StyledContainerTop = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "block" : "flex",
}))`
  display: ${(props) => props.display};
  justify-content: space-between;
  margin-bottom: 24px;
  display: ;
`;

const StyledContainerTopBar = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "none" : "block",
}))`
  display: ${(props) => props.display};
`;
